<nx-message context="error" *ngIf="error==false"> 
  <div>
    {{'evrotrust.download-evrotrust-title' | translate}}
</div>
<div style="margin-top: 10px;">
  {{'evrotrust.download-evrotrust-subtitle' | translate}}
</div>
  <div nxLayout="grid">
  
    <div nxRow nxRowJustify="center" nxRowAlignItems="center" class="downloadButtons">
      <div nxCol="5" style="text-align: end;">
        <a class="link-img" href="https://play.google.com/store/apps/details?id=com.evrotrust.app" target="_blank">
          <img alt="Get it on Google Play" src="../../../../assets/img/google-play-badge.png" class="image-icon" />
        </a>
      </div>
      <div nxCol="5">
        <a href="https://apps.apple.com/bg/app/evrotrust/id1195807317" target="_blank">
          <img class="image-icon-svg" src="../../../../assets/img/apple-black.svg" alt="image" />
        </a>
      </div>
    </div>
  </div>
  
</nx-message>


    <nx-message context="error" *ngIf="error==true">  {{ data.subheading | translate}} </nx-message>
